import { Check, Tags } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

/** Uma categoria da conta com as páginas ativas dela. */
export type Categoria = { id: number; nome: string; paginas: Set<string> };

/**
 * Quais categorias o grupo usa, entre todas da conta. É o que o "Atualizar pelas
 * categorias" segue: categoria que o grupo não usa não entra, por mais páginas
 * que tenha — e é por isso que um grupo pode ficar com menos páginas que outro.
 */
export default function CategoriasDoGrupo({ paginas, categorias }: { paginas: string[]; categorias: Categoria[] }) {
    if (categorias.length === 0) return null;
    const doGrupo = new Set(paginas);
    const linhas = categorias
        .map((c) => ({ ...c, noGrupo: [...c.paginas].filter((p) => doGrupo.has(p)).length }))
        .sort((a, b) => Number(b.noGrupo > 0) - Number(a.noGrupo > 0) || a.nome.localeCompare(b.nome));
    const usadas = linhas.filter((c) => c.noGrupo > 0).length;

    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    className="inline-flex shrink-0 items-center gap-1 rounded-md px-1.5 py-0.5 text-xs text-muted-foreground hover:bg-muted"
                    title="Categorias que este grupo usa"
                >
                    <Tags className="h-3.5 w-3.5" />
                    <span className="tabular-nums">{usadas}/{categorias.length}</span>
                </button>
            </PopoverTrigger>
            <PopoverContent align="start" className="w-72 p-0">
                <p className="border-b px-3 py-2 text-xs text-muted-foreground">
                    Usa <strong className="text-foreground">{usadas}</strong> de {categorias.length} categorias.
                    "Atualizar pelas categorias" só completa as marcadas.
                </p>
                <ul className="max-h-72 overflow-y-auto py-1 text-sm">
                    {linhas.map((c) => (
                        <li key={c.id} className={`flex items-center gap-2 px-3 py-1 ${c.noGrupo ? '' : 'text-muted-foreground'}`}>
                            <Check className={`h-3.5 w-3.5 shrink-0 ${c.noGrupo ? 'text-emerald-600' : 'invisible'}`} />
                            <span className="flex-1 truncate">{c.nome}</span>
                            <span className="shrink-0 text-xs tabular-nums">{c.noGrupo}/{c.paginas.size}</span>
                        </li>
                    ))}
                </ul>
            </PopoverContent>
        </Popover>
    );
}
